
import React, { useState, useEffect } from "react";
import { User } from "@supabase/supabase-js";
import { supabase } from "@/integrations/supabase/client";
import { ProductList } from "./product/ProductList";
import { ContentList } from "./product/ContentList";
import { ProductAIChatbot } from "./product/ProductAIChatbot";
import { useProductData } from "./product/useProductData";

export const ProductTab: React.FC = () => {
  const [user, setUser] = useState<User | null>(null);

  const {
    projects,
    selectedProject,
    contents,
    setSelectedProject,
    handleCreateProject,
    handleCreateContent,
    handleEditContent,
    handleDeleteProject,
    handleDeleteContent,
    handleEditProject
  } = useProductData(user);

  useEffect(() => {
    const getUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      setUser(user);
    };

    getUser();

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });

    return () => subscription.unsubscribe();
  }, []);

  return (
    <div className="flex flex-col gap-4">
      <p className="text-[12px] text-secondary-light">Use AI to evaluate and gain insights about your own or competitor's product or service being offered to customers, including its features, design, quality and external reviews (if available).</p>
      
      <div className="flex gap-4">
        <div className="flex flex-col gap-4 w-[60%]">
          <ProductList
            projects={projects}
            selectedProject={selectedProject}
            onSelectProject={setSelectedProject}
            onCreateProject={handleCreateProject}
            onEditProject={handleEditProject}
            onDeleteProject={handleDeleteProject}
          />

          <ContentList
            selectedProject={selectedProject}
            contents={contents}
            onCreateContent={handleCreateContent}
            onEditContent={handleEditContent}
            onDeleteContent={handleDeleteContent}
          />
        </div>

        <ProductAIChatbot contents={contents} />
      </div>
    </div>
  );
};

export default ProductTab;
